<template>
  <div>
    <Head :title="title" />
    <div class="bg-white rounded-md shadow overflow-hidden max-w-3xl">
      <form @submit.prevent="store">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
          <text-input v-model="form.name" :error="form.errors.name" class="pr-6 pb-8 w-full lg:w-full" :label="__('Name')" />
          <text-input v-model="form.level" :error="form.errors.level" class="pr-6 pb-8 w-full lg:w-full" :label="__('Level')" />
        </div>
        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex justify-end items-center">
          <loading-button :loading="form.processing" class="btn-indigo" type="submit">{{ __('Create') }} {{ __('Priority') }}</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Link, Head } from '@inertiajs/vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'

export default {
  metaInfo: { title: 'Create Priority' },
  components: {
    LoadingButton,
    TextInput,
    Link,
    Head,
  },
  layout: Layout,
  props: {
      title: String,
      level:Number,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        name: null,
          level: 0,
        color: null,
      }),
    }
  },
  methods: {
    store() {
      // Validate that level is a number before submitting
      if (isNaN(this.form.level) || this.form.level === null || this.form.level === '') {
        this.form.errors.level = this.__('Level must be a number');
        return;
      } else {
        this.form.errors.level = null;
      }
      this.form.post(this.route('priorities.store'))
    },
  },
}
</script>
